export enum RequestDayFilterEnum {
    Within15DaysDescription = 'Within 15 Days',
    WithIn15Days = 1,
    Within30DaysDescription = 'Within 30 Days',
    Within30Days = 2
}
